import * as React from "react";
import { useSiteData } from "../../hooks/use_site";
import InfoCard from "../general/info_card";
import {
  getAddressEAN,
  getCompanyName,
  getEAN,
  getContractStartDate,
  getVatNumber,
} from "../../scripts/data_format_utils";

export default function ContractCard({ contractType, ...props }) {
  const { data: siteData } = useSiteData();

  const companyName = getCompanyName(siteData, contractType);
  const vatNumber = getVatNumber(siteData, contractType);
  const ean = getEAN(siteData, contractType);
  const addressEan = getAddressEAN(siteData, contractType);
  const startDate = getContractStartDate(siteData, contractType);

  return (
    <InfoCard
      title={contractType + " Contract"}
      {...props}
      content={[
        { key: "company", value: companyName },
        { key: "vat n°", value: vatNumber },
        { key: "ean", value: ean },
        { key: "address", value: addressEan },
        { key: "startDate", value: startDate },
      ]}
    />
  );
}
